import api from '@/libs/api'
import store from '@/store'

const getProjectId = () => store.state.app.projectId

export default {
  namespaced: true,
  state: {
    // STANDBY NODES
    standbyNodes: 0,
    standbyNodesCreating: false,
    serviceUnavailable: false,
    serviceRequested: false,
    clusters: [],
    clustersResultInfo: {},
    fetchingClusters: false,
    cluster: null,
    fetchingCluster: false,
    creatingCluster: false,
    updatingCluster: false,
    deletingCluster: false,
    restoringCluster: false,
    // Cluster database
    clusterDatabases: null,
    fetchingClusterDatabases: false,
    clusterDatabase: null,
    fetchingClusterDatabase: false,
    creatingClusterDatabase: false,
    deletingClusterDatabase: false,
    // Data center
    datacenters: null,
    fetchingDatacenters: false,
    // Engines
    engines: null,
    fetchingEngines: false,
    // Plans
    instancePresets: null,
    fetchingInstancePresets: false,
    // Trusted sources
    fetchingTrustedSources: false,
    updatingTrustedSources: false,
    // Cluster users
    clusterUsers: null,
    fetchingClusterUsers: false,
    clusterUser: null,
    fetchingClusterUser: false,
    creatingClusterUser: false,
    updatingClusterUser: false,
    // Eviction policy
    fetchingEvictionPolicies: false,
    evictionPolicies: [],
    evictionPolicy: {},
    gettingEvictionPolicy: false,
    updatingEvictionPolicy: false,
    // Connection Pools
    fetchingConnectionPools: false,
    connectionPools: [],
    connectionPool: {},
    addingConnectionPool: false,
    gettingConnectionPool: false,
    updatingConnectionPool: false,
    deletingConnectionPool: false,
  },
  mutations: {
    SET_SERVICE_UNAVAILABLE(state, value) {
      state.serviceUnavailable = true
      state.serviceRequested = value
    },
    SET_FETCHING_CLUSTERS(state, value) {
      state.fetchingClusters = value
    },
    SET_CLUSTERS(state, value) {
      state.clusters = value.result
      if (value.resultInfo) {
        state.clustersResultInfo = value.resultInfo
      }
    },
    SET_FETCHING_CLUSTER(state, value) {
      state.fetchingCluster = value
    },
    SET_CLUSTER(state, value) {
      state.cluster = value
    },
    SET_CREATING_CLUSTER(state, value) {
      state.creatingCluster = value
    },
    SET_UPDATING_CLUSTER(state, value) {
      state.updatingCluster = value
    },
    SET_DELETING_CLUSTER(state, value) {
      state.deletingCluster = value
    },
    // Cluster Databases
    SET_CLUSTER_DATABASES(state, value) {
      state.clusterDatabases = value
    },
    SET_FETCHING_CLUSTER_DATABASES(state, value) {
      state.fetchingClusterDatabases = value
    },
    SET_CLUSTER_DATABASE(state, value) {
      state.clusterDatabase = value
    },
    SET_FETCHING_CLUSTER_DATABASE(state, value) {
      state.fetchingClusterDatabase = value
    },
    SET_CREATING_CLUSTER_DATABASE(state, value) {
      state.creatingClusterDatabase = value
    },
    SET_DELETING_CLUSTER_DATABASE(state, value) {
      state.deletingClusterDatabase = value
    },
    SET_RESTORING_CLUSTER(state, value) {
      state.restoringCluster = value
    },
    // Data Centers
    SET_FETCHING_DATA_CENTERS(state, value) {
      state.fetchingDatacenters = value
    },
    SET_DATA_CENTERS(state, value) {
      state.datacenters = value
    },
    // Engines
    SET_FETCHING_ENGINES(state, value) {
      state.fetchingEngines = value
    },
    SET_ENGINES(state, value) {
      state.engines = value
    },
    SET_FETCHING_INSTANCE_PRESETS(state, value) {
      state.fetchingInstancePresets = value
    },
    // Plans
    SET_INSTANCE_PRESETS(state, value) {
      state.instancePresets = value
    },
    SET_FETCHING_TRUSTED_SOURCES(state, value) {
      state.fetchingTrustedSources = value
    },
    // Trusted Sources
    SET_TRUSTED_SOURCES(state, res) {
      state.cluster = { ...state.cluster, trustedSources: res }
    },
    SET_UPDATING_TRUSTED_SOURCES(state, value) {
      state.updatingTrustedSources = value
    },
    // Cluster Users
    SET_CLUSTER_USERS(state, value) {
      state.clusterUsers = value
    },
    SET_FETCHING_CLUSTER_USERS(state, value) {
      state.fetchingClusterUsers = value
    },
    SET_CLUSTER_USER(state, value) {
      state.clusterUser = value
    },
    SET_FETCHING_CLUSTER_USER(state, value) {
      state.fetchingClusterUser = value
    },
    SET_CREATING_CLUSTER_USER(state, value) {
      state.creatingClusterUser = value
    },
    SET_DELETING_CLUSTER_USER(state, value) {
      state.deletingClusterUser = value
    },
    SET_UPDATING_CLUSTER_USER(state, value) {
      state.updatingClusterUser = value
    },
    // Eviction policy
    SET_EVICTION_POLICIES(state, value) {
      state.evictionPolicies = value
    },
    SET_FETCHING_EVICTION_POLICIES(state, value) {
      state.fetchingEvictionPolicies = value
    },
    SET_EVICTION_POLICY(state, value) {
      state.evictionPolicy = value
    },
    SET_GETTING_EVICTION_POLICY(state, value) {
      state.gettingEvictionPolicy = value
    },
    SET_UPDATING_EVICTION_POLICY(state, value) {
      state.updatingEvictionPolicy = value
    },
    SET_CLUSTER_EVICTION_POLICY(state, id) {
      state.cluster.evictionPolicyId = id
    },
    // STANDBY NODES
    SET_UPDATE_STANBY_NODES(state, value) {
      state.standbyNodes = value
    },
    SET_CREATING_STANDBY_NODES(state, value) {
      state.standbyNodesCreating = value
    },
    // Connection Pools
    SET_FETCHING_CONNECTION_POOLS(state, value) {
      state.fetchingConnectionPools = value
    },
    SET_CONNECTION_POOLS(state, value) {
      state.connectionPools = value
    },
    SET_GETTING_CONNECTION_POOL(state, value) {
      state.gettingConnectionPool = value
    },
    SET_CONNECTION_POOL(state, value) {
      state.connectionPool = value
    },
    SET_ADDING_CONNECTION_POOL(state, value) {
      state.addingConnectionPool = value
    },
    SET_UPDATING_CONNECTION_POOL(state, value) {
      state.updatingConnectionPool = value
    },
    SET_DELETING_CONNECTION_POOL(state, value) {
      state.deletingConnectionPool = value
    },
    DELETE_CONNECTION_POOL(state, id) {
      state.connectionPools = state.connectionPools.filter(e => e.id !== id)
    },
  },
  actions: {
    updateStandbyNodes({ commit }, payload) {
      commit('SET_CREATING_STANDBY_NODES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(
            `/projects/${getProjectId()}/clusters/${payload.id}/updatenodes`,
            payload,
          )
          .then(res => {
            commit('SET_UPDATE_STANBY_NODES', payload.standbyNodes)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_CREATING_STANDBY_NODES', false)
          })
      })
    },

    fetchClusters({ commit }, { pageIndex, pageSize }) {
      const paginationString = `?PageIndex=${pageIndex
        || 0}&PageSize=${pageSize || 10}`

      commit('SET_FETCHING_CLUSTERS', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters${paginationString}`)
          .then(res => {
            commit('SET_CLUSTERS', res.data)
            resolve(res)
          })
          .catch(err => {
            if (err.response?.status === 426 || err.response?.status === 428) {
              commit('SET_SERVICE_UNAVAILABLE', err.response?.status === 428)
            }
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_CLUSTERS', false)
          })
      })
    },
    fetchClusterById({ commit }, id) {
      commit('SET_FETCHING_CLUSTER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${id}`)
          .then(res => {
            commit('SET_CLUSTER', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_CLUSTER', false)
          })
      })
    },
    createCluster({ commit }, payload) {
      commit('SET_CREATING_CLUSTER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .post(`/projects/${getProjectId()}/clusters`, payload)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_CREATING_CLUSTER', false)
          })
      })
    },
    updateCluster({ commit }, payload) {
      commit('SET_UPDATING_CLUSTER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(`/projects/${getProjectId()}/clusters/${payload.id}`, payload)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_CLUSTER', false)
          })
      })
    },
    deleteCluster({ commit }, clusterId) {
      commit('SET_DELETING_CLUSTER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .delete(`/projects/${getProjectId()}/clusters/${clusterId}`)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_DELETING_CLUSTER', false)
          })
      })
    },
    resetClusterStore({ commit }) {
      commit('SET_CLUSTER', null)
    },
    // Cluster Database
    fetchClusterDatabases({ commit }, id) {
      commit('SET_FETCHING_CLUSTER_DATABASES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${id}/databases`)
          .then(res => {
            commit('SET_CLUSTER_DATABASES', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_CLUSTER_DATABASES', false)
          })
      })
    },
    fetchClusterDatabaseById({ commit }, { clusterId, databaseId }) {
      commit('SET_FETCHING_CLUSTER_DATABASE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(
            `/projects/${getProjectId()}/clusters/${clusterId}/databases/${databaseId}`,
          )
          .then(res => {
            commit('SET_CLUSTER_DATABASE', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_CLUSTER_DATABASE', false)
          })
      })
    },
    createClusterDatabase({ commit }, { name, clusterId }) {
      commit('SET_CREATING_CLUSTER_DATABASE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .post(`/projects/${getProjectId()}/clusters/${clusterId}/databases`, {
            name,
          })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_CREATING_CLUSTER_DATABASE', true)
          })
      })
    },
    deleteClusterDatabase({ commit }, { clusterId, databaseId }) {
      commit('SET_DELETING_CLUSTER_DATABASE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .delete(
            `/projects/${getProjectId()}/clusters/${clusterId}/databases/${databaseId}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_DELETING_CLUSTER_DATABASE', false)
          })
      })
    },
    restoreCluster({ commit }, payload) {
      commit('SET_RESTORING_CLUSTER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .post(
            `/projects/${getProjectId()}/clusters/${payload.clusterId}`,
            payload.obj,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_RESTORING_CLUSTER', false)
          })
      })
    },
    // Data centers
    fetchDataCenters({ commit }) {
      commit('SET_FETCHING_DATA_CENTERS', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/datacenters`)
          .then(res => {
            commit('SET_DATA_CENTERS', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_DATA_CENTERS', false)
          })
      })
    },
    // Engines
    fetchEngines({ commit }) {
      commit('SET_FETCHING_ENGINES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/engines`)
          .then(res => {
            commit('SET_ENGINES', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_ENGINES', false)
          })
      })
    },
    // Plans
    fetchInstancePresets({ commit }) {
      commit('SET_FETCHING_INSTANCE_PRESETS', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/plans`)
          .then(res => {
            commit('SET_INSTANCE_PRESETS', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_INSTANCE_PRESETS', false)
          })
      })
    },
    // Trusted Sources
    fetchTrustedSourcesById({ commit }, id) {
      commit('SET_FETCHING_TRUSTED_SOURCES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/sources/${id}`)
          .then(res => {
            const sources = res.data?.result?.map(el => el.value)
            commit('SET_TRUSTED_SOURCES', sources)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_TRUSTED_SOURCES', false)
          })
      })
    },
    updateTrustedSources({ commit }, { id, sources }) {
      commit('SET_UPDATING_TRUSTED_SOURCES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(`/projects/${getProjectId()}/sources/${id}`, { sources })
          .then(res => {
            commit('SET_TRUSTED_SOURCES', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_TRUSTED_SOURCES', false)
          })
      })
    },
    // User
    fetchClusterUsers({ commit }, id) {
      commit('SET_FETCHING_CLUSTER_USERS', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${id}/users`)
          .then(res => {
            commit('SET_CLUSTER_USERS', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_CLUSTER_USERS', false)
          })
      })
    },
    fetchClusterUserById({ commit }, { clusterId, databaseId }) {
      commit('SET_FETCHING_CLUSTER_USER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(
            `/projects/${getProjectId()}/clusters/${clusterId}/users/${databaseId}`,
          )
          .then(res => {
            commit('SET_CLUSTER_USER', res.data.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_CLUSTER_USER', false)
          })
      })
    },
    createClusterUser({ commit }, { username, clusterId }) {
      commit('SET_CREATING_CLUSTER_DATABASE', true)
      return new Promise((resolve, reject) => {
        api('database')
          .post(`/projects/${getProjectId()}/clusters/${clusterId}/users`, {
            username,
          })
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_CREATING_CLUSTER_DATABASE', true)
          })
      })
    },
    updateClusterUser({ commit }, { userId, clusterId }) {
      commit('SET_UPDATING_CLUSTER_USER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(
            `/projects/${getProjectId()}/clusters/${clusterId}/users/${userId}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_CLUSTER_USER', false)
          })
      })
    },
    deleteClusterUser({ commit }, { clusterId, userId }) {
      commit('SET_DELETING_CLUSTER_USER', true)
      return new Promise((resolve, reject) => {
        api('database')
          .delete(
            `/projects/${getProjectId()}/clusters/${clusterId}/users/${userId}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_DELETING_CLUSTER_USER', false)
          })
      })
    },
    // eslint-disable-next-line no-empty-pattern
    validateClusterName({}, name) {
      return new Promise(resolve => {
        api('database')
          .head(`/projects/${getProjectId()}/clusters/${name}`)
          .then(() => {
            resolve({ isValid: false, nameExists: true })
          })
          .catch(err => {
            if (err.response && err.response.status === 404) resolve({ isValid: true, nameExists: false })
            resolve({ isValid: false, nameExists: false })
          })
      })
    },
    // Eviction policies
    fetchEvictionPolicies({ commit }, id) {
      commit('SET_FETCHING_EVICTION_POLICIES', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${id}/evictionPolicy`)
          .then(res => {
            commit('SET_EVICTION_POLICIES', res.data?.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_EVICTION_POLICIES', false)
          })
      })
    },
    updateEvictionPolicy({ commit }, { id, clusterId }) {
      commit('SET_UPDATING_EVICTION_POLICY', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(
            `/projects/${getProjectId()}/clusters/${clusterId}/evictionPolicy/${id}`,
          )
          .then(res => {
            commit('SET_CLUSTER_EVICTION_POLICY', id)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_EVICTION_POLICY', false)
          })
      })
    },
    // Connection Pools
    // eslint-disable-next-line no-empty-pattern
    validateConnectionPoolName({}, { clusterId, name }) {
      return new Promise(resolve => {
        api('database')
          .head(`/projects/${getProjectId()}/clusters/${clusterId}/connectionpool/${name}`)
          .then(() => {
            resolve({ isValid: false, nameExists: true })
          })
          .catch(err => {
            if (err.response && err.response.status === 404) resolve({ isValid: true, nameExists: false })
            resolve({ isValid: false, nameExists: false })
          })
      })
    },
    fetchConnectionPools({ commit }, clusterId) {
      commit('SET_FETCHING_CONNECTION_POOLS', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${clusterId}/connectionpool`)
          .then(res => {
            commit('SET_CONNECTION_POOLS', res.data?.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_FETCHING_CONNECTION_POOLS', false)
          })
      })
    },
    getConnectionPool({ commit }, { clusterId, id }) {
      commit('SET_GETTING_CONNECTION_POOL', true)
      return new Promise((resolve, reject) => {
        api('database')
          .get(`/projects/${getProjectId()}/clusters/${clusterId}/connectionpool/${id}`)
          .then(res => {
            commit('SET_CONNECTION_POOL', res.data?.result)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_GETTING_CONNECTION_POOL', false)
          })
      })
    },
    addConnectionPool({ commit }, { connectionPool, clusterId }) {
      commit('SET_ADDING_CONNECTION_POOL', true)
      return new Promise((resolve, reject) => {
        api('database')
          .post(`/projects/${getProjectId()}/clusters/${clusterId}/connectionpool`, connectionPool)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_ADDING_CONNECTION_POOL', false)
          })
      })
    },
    updateConnectionPool({ commit }, { id, clusterId, connectionPool }) {
      commit('SET_UPDATING_CONNECTION_POOL', true)
      return new Promise((resolve, reject) => {
        api('database')
          .put(
            `/projects/${getProjectId()}/clusters/${clusterId}/connectionpool/${id}`,
            connectionPool,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_UPDATING_CONNECTION_POOL', false)
          })
      })
    },
    deleteConnectionPool({ commit }, { clusterId, id }) {
      commit('SET_DELETING_CONNECTION_POOL', true)
      return new Promise((resolve, reject) => {
        api('database')
          .delete(
            `/projects/${getProjectId()}/clusters/${clusterId}/connectionpool/${id}`,
          )
          .then(res => {
            commit('DELETE_CONNECTION_POOL', id)
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('SET_DELETING_CONNECTION_POOL', false)
          })
      })
    },
  },
}
